import graphql from 'babel-plugin-relay/macro';
import createMutation from '../../helpers/createMutation';

const mutation = graphql`
    mutation StripeCancelSubscriptionMutation($input: Stripe__CancelSubscriptionInput!) {
        stripeCancelSubscription(input: $input) {
            success
            error
        }
    }
`;

const commit = () =>
  createMutation({
      mutation,
      variables: {
          input: {}
      }
  });

export default { commit };
